/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { useQuery } from 'react-query'

import { getItemizedCostsByInstanceV2 } from '@modules/billing-api/v1/callers'
import type { operations } from '@modules/billing-api/v1/types'
import type { QueryHook, QueryHookOptions } from '@modules/query/types'

import { defaultBillingOptions } from './constants'

const useGetInstanceCostItems: QueryHook<typeof getItemizedCostsByInstanceV2> = (
  args: {
    pathParameters: operations['getItemizedCostsByInstanceV2']['parameters']['path']
    queryParameters: operations['getItemizedCostsByInstanceV2']['parameters']['query']
  },
  options?: QueryHookOptions,
) =>
  useQuery(
    [
      `getItemizedCostsByInstanceV2`,
      args.pathParameters.organization_id,
      args.pathParameters.instance_id,
      args.queryParameters.from,
      args.queryParameters.to,
    ],
    () => getItemizedCostsByInstanceV2(args),
    {
      ...defaultBillingOptions,
      ...options,
    },
  )

export default useGetInstanceCostItems
